// Opening the app lands on the Main Page (#512 PO re-open, 2026-10-29).
//
// A sign-in from the login form already lands on `/home` (LoginPage). What still
// opened "straight into the last conversation" was OPENING the app — a new tab
// or a restarted browser at the app's address while Firebase still remembers
// the session: the address is `/`, the Main Chat, which restores
// `omnis:last-conversation-id`. So the FIRST page load of a browser tab at the
// bare address goes to `/home` instead. A reload of that tab keeps where it
// was (sessionStorage is per tab and survives reloads), and every other entry
// keeps its URL: `/chat/:id` links from Telegram replies, feature
// routes, and the Stripe returns (`/?billing=…` carries a query).
const TAB_OPENED_KEY = 'pai:tab-opened';

/** Where the first load of a tab should go instead, or null to stay. Pure. */
export function entryLandingPath({ pathname, search, tabAlreadyOpened }) {
    if (tabAlreadyOpened) return null;
    if (pathname === '/' && !search) return '/home';
    return null;
}

/** Runs once before React mounts (main.jsx); rewrites the URL in place. */
export function applyEntryLanding(win = window) {
    let tabAlreadyOpened = false;
    try {
        tabAlreadyOpened = win.sessionStorage.getItem(TAB_OPENED_KEY) === '1';
        win.sessionStorage.setItem(TAB_OPENED_KEY, '1');
    } catch (_) { /* sessionStorage can throw in private mode — treat as a new tab */ }
    const target = entryLandingPath({
        pathname: win.location.pathname,
        search: win.location.search,
        tabAlreadyOpened,
    });
    if (target) win.history.replaceState(win.history.state, '', target + win.location.hash);
    return target;
}
